import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';
import CloseOutWorked from './CloseOutWorked';
import CloseOutImprove from './CloseOutImprove';
import CloseOutScope from './CloseOutScope';
import CloseOutCost from './CloseOutCost';
import CloseOutSchedule from './CloseOutSchedule';
import Button from '@material-ui/core/Button';
import moment from 'moment';

//Progress
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  ROLE_VIEWER
} 
from '../common/redux/constantes';

//validators
// import {validateField} from '../common/redux/validators';


const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    position:"relative",
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
      marginTop: theme.spacing.unit * 6,
      marginBottom: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 3,
    },
    minHeight:600,
  },
  stepper: {
    padding: `${theme.spacing.unit * 3}px 0 ${theme.spacing.unit * 5}px`,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    bottom:"20px !important",
    right:"20px !important",
    position:"absolute"
  },
  buttons_left: {
    display: 'flex',
    justifyContent: 'flex-end',
    bottom:"20px !important",
    left:"20px !important",
    position:"absolute"
  },
  button_left: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
  },
});

const steps = [
  'First', 
  'Second',
  'Scope',
  'Schedule',
  'Cost'
];

class CloseOutProject extends Component {
 

  constructor(props)
  {
    super(props);

    //Bindings
    this.handleChange=this.handleChange.bind(this);
    this.saveCloseOut=this.saveCloseOut.bind(this);
    this.createReport =this.createReport.bind(this);

    //Primer estado
    let closeout = {
      closeout:0,
      project:props.project,
      scope_worked:'',
      schedule_worked:'',
      cost_worked:'',
      other_worked:'',
      scope_improve:'',
      schedule_improve:'',
      cost_improve:'',
      other_improve:''
    };

    let report = {
      w_targeted:0,
      w_completed:0,
      w_effectiveness:0
    }

    let activeStep = 0;

    
    this.state = {
      activeStep: activeStep,
      closeout:closeout,
      report:report,
      errores:{},
      pdf_disabled:false
    }; 


    
  }

  componentWillMount()
  {

    this.props.actions.fetchCloseOut(this.props.project)
    .then(res=>{
      if(res && res.close_outs && res.close_outs.length>0)
      {
        this.setState({closeout:res.close_outs[0]});
      }
    });

    this.props.actions.fetchResume(this.props.project)
    .then(res=>{
      if(res.success === 1 && res.report && res.report.length === 2)
      {
        let w_resume = res.report[0].length>0?res.report[0][0]:{};
        let w_targeted = w_resume.wnc + w_resume.wc;
        let w_completed = w_resume.wc; 
        let w_effectiveness = w_completed/w_targeted;
        w_effectiveness = w_effectiveness * 100;
        w_effectiveness = w_effectiveness.toFixed(2);
        let report = this.state.report;
        report.w_targeted = w_targeted;
        report.w_completed = w_completed;
        report.w_effectiveness = w_effectiveness;

        report.symbol = w_resume.symbol;

        let rps = res.report[1];



        let planned_start_date = moment(w_resume.planned_start_date);
        let planned_end_date = moment(w_resume.planned_end_date);
        let actual_start_date = moment(w_resume.real_start_date);
        let actual_end_date = moment(w_resume.real_end_date);
        
       
        

        let variance_start_date = actual_start_date.diff(planned_start_date, 'days');
        let variance_end_date = actual_end_date.diff(planned_end_date,'days');
        let planned_duration = planned_end_date.diff(planned_start_date,'days');
        let actual_duration = actual_end_date.diff(actual_start_date, 'days');

        report.planned_duration = planned_duration;
        report.actual_duration = actual_duration;
        report.planned_start_date = planned_start_date.format('YYYY/MM/DD');
        report.actual_start_date = actual_start_date.format('YYYY/MM/DD');
        report.planned_end_date = planned_end_date.format('YYYY/MM/DD');
        report.actual_end_date = actual_end_date.format('YYYY/MM/DD');
        if(variance_end_date > 0)
        {
          report.schedule = "Behind Schedule";
        }else if(variance_end_date===0)
        {
          report.schedule = "On Schedule";
        }else
        {
          report.schedule = 'Ahead of Schedule';
        }

        report.variance_start_date = variance_start_date;
        report.variance_end_date = variance_end_date;

        let valido = true;
        if(!w_resume.planned_start_date)
        {
          valido = false;
          report.planned_start_date = "No Data";
        }
        
        if(!w_resume.planned_end_date)
        {
          valido = false;
          report.planned_end_date = "No Data";
        }
        
        if(!w_resume.real_start_date)
        {
          valido = false;
          report.actual_start_date = "No Data";
        }
          

        if(!w_resume.real_end_date)
        {
          valido = false;
          report.actual_end_date = "No Data";
        }

        if(!valido)
        {
          report.planned_duration = "No Data";
          report.actual_duration = "No Data";
          report.schedule = "No Data";
          report.variance_start_date = "No Data";
          report.variance_end_date = "No Data";
        }



        let formatter = null;
        if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
        {
          formatter = new Intl.NumberFormat('gt-GT', {
            minimumFractionDigits: 2,
          });
        }




        
        let cumulative_actual = 0;
        let cumulative = 0;
        // let cumulative_earned = 0;
        rps.map(o => {
            cumulative += Number(o.planned_value);
            // cumulative_earned += Number(o.earned_value);
            cumulative_actual += Number(o.actual_cost);
          return o;
        });
        let variance = cumulative_actual- cumulative;
        if(variance<0)
          variance*=-1;
        let over_budget =  cumulative_actual>cumulative;

        if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
        {
            // o.planned_value = formatter.format(o.planned_value);
            cumulative =  formatter.format(cumulative);
            cumulative_actual = formatter.format(cumulative_actual);
            // cumulative_earned = formatter.format(cumulative_earned);
            variance = formatter.format(variance);
        }

        report.planned_cost = cumulative;
        report.actual_cost = cumulative_actual;
        report.variance = variance;
        if(over_budget)
        {
          report.budget = "Over Budget";
        }else
        {
          report.budget = "On Budget";
        }
        this.setState({report:report});
      }
    });
  }


  getStepContent(step) 
  {
    switch (step) {
      case 0:
        return <CloseOutWorked handleChange={this.handleChange} errores={this.state.errores} closeout={this.state.closeout} reviewActive={(this.props.user_role===ROLE_VIEWER)}/>;
      case 1:
        return <CloseOutImprove handleChange={this.handleChange} errores={this.state.errores} closeout={this.state.closeout} reviewActive={(this.props.user_role===ROLE_VIEWER)}/>;
      case 2:
        return <CloseOutScope  report={this.state.report}/>;
      case 3:
        return <CloseOutSchedule  report={this.state.report}/>;
      case 4:
        return <CloseOutCost  report={this.state.report}/>;
      default:
        throw new Error('Unknown step');
    }
  }

   handleNext = () => {
    if(steps.length - 1 === this.state.activeStep && this.props.user_role!==ROLE_VIEWER)
    {
      //Solo puede guardar si está valido el form
      if(!this.validateForm()){
        return;
      }

      //Si es el último step hay que guardar el project. 
      this.saveCloseOut();
    }
    else if(steps.length - 1 === this.state.activeStep)
    {
      //Por petición se hizo que si está sólo mostrando datos en el botón next se cierre la pantalla.
      this.props.onCloseAction();
      return;
    }

    this.setState(state => ({
      activeStep: state.activeStep + 1,
    }));
  };


  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleChange(event) {
    //Si sólo se está mostrando la información no cambia nada.
    if(this.props.user_role === ROLE_VIEWER )
      return;

    const target = event.target;
    const value = target.value;
    const name = target.id? target.id:target.name;
    let closeout = this.state.closeout;
    closeout[name] = value;

    this.validateForm();

    this.setState({
      closeout: closeout,
    });
    this.validateForm();
  }

  validateForm = ()=>{
    let errores = {};
    let valido = true;
    let closeout = {
      scope_worked:'',
      schedule_worked:'',
      cost_worked:'',
      other_worked:'',
      scope_improve:'',
      schedule_improve:'',
      cost_improve:'',
      other_improve:''
    };

    //Validando atributos almenos ingresados
    for (const attribute in closeout) 
    {
      
      // if (!validateField(this.state.closeout[attribute])) 
      // {
      //   errores[attribute]= 'Must fill all the fields';
      //   valido = false;
      // }
      if (this.state.closeout[attribute].length>799) 
      {
        errores[attribute]= 'Maximum size: 800';
        valido = false;
      }
    }


    this.setState({
      errores: errores,
    });
    return valido;
  }

  saveCloseOut()
  {

    this.props.actions.saveCloseOut(this.state.closeout);
    
  }

  createReport()
  {
    this.setState({pdf_disabled:true})
    this.props.actions.getCloseOutReport(this.state.closeout.project)
    .finally(()=>this.setState({pdf_disabled:false}))
  }

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const {savePending, fragmentContent,fragmentTitle } = this.props.home;
    const {activeStep, pdf_disabled} = this.state;
    let title = "Close Out";
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
              {title}
            </Typography>
            <Stepper activeStep={activeStep} className={classes.stepper}>
              {steps.map(label => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <React.Fragment>
              {activeStep === steps.length ? (
                <div>
                  {savePending ? 
                  (
                    <CircularProgress />
                  ):(
                    <React.Fragment>
                      <Typography variant="h5" gutterBottom>
                        {fragmentTitle}
                      </Typography>
                      <Typography variant="subtitle1">
                      {fragmentContent}
                      </Typography>
                    </React.Fragment>
                  )}
                </div>
              ) : (
                <React.Fragment >
                  <div style={{marginBottom:"20px !important"}}>
                    {this.getStepContent(activeStep)}
                  </div>
                  <div className={classes.buttons}>
                    {(activeStep !== 0) && (
                      <Button
                        onClick={this.handleBack}
                        className={classes.button}
                      >
                        Back
                      </Button>
                    )}
                    {(true) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleNext}
                        className={classes.button}
                      > 
                        {activeStep === steps.length - 1 ? this.props.user_role===ROLE_VIEWER? "Close":"Save" : "Next"}
                      </Button>
                    )}
                  </div>
                  {(this.state.closeout.closeout)?  (
                    <div className={classes.buttons_left}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.createReport}
                        className={classes.button_left}
                        disabled={pdf_disabled}
                      > 
                        PDF
                      </Button>
                    </div>
                  ): null}
                </React.Fragment>
              )}
            </React.Fragment>
          </Paper>
        </main>
      </React.Fragment>
    );
  }
}

CloseOutProject.propTypes = {
  classes: PropTypes.object.isRequired,
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(CloseOutProject));



// WEBPACK FOOTER //
// ./src/features/home/CloseOutProject.js